import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { fg } from '@confluence/feature-gating';
import { LoadableAfterPaint } from '@confluence/loadable';
import { useShouldShowTwcAifcOnboarding } from '@confluence/smart-create/entry-points/useShouldShowTwcAifcOnboarding.ts';

const SmartCreationModalLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartCreationModal" */
				'@confluence/smart-create/entry-points/smartCreationModal.tsx'
			)
		).ConfluenceSmartCreationModalLoader,
});

export const SmartCreationComponentLoader = () => {
	const { shouldShow: shouldShowTwcAifc } = useShouldShowTwcAifcOnboarding();
	if (!fg('aifc_create_enabled') && !shouldShowTwcAifc) {
		return null;
	}

	return (
		<ErrorBoundary
			attribution={Attribution.SMARTS}
			attributes={{
				errorBoundaryId: 'GlobalComponents-Smarts',
			}}
		>
			<SmartCreationModalLoadable />
		</ErrorBoundary>
	);
};
